import { render, staticRenderFns } from "./Pengeluaran.vue?vue&type=template&id=06561942"
import script from "./Pengeluaran.vue?vue&type=script&lang=js"
export * from "./Pengeluaran.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports